import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/Gallery.css";

import s1 from "../assets/image/s1.jpg";
import s2 from "../assets/image/s7.jpg";
import s3 from "../assets/image/s6.jpg";
import s4 from "../assets/image/hero-bg1.jpg";
import s5 from "../assets/image/s9.jpg";
import s6 from "../assets/image/s5.jpg";

const projects = [
  {
    id: 1,
    category: "Software",
    title: "Enterprise CRM",
    img: s1,
  },
  {
    id: 2,
    category: "CCTV",
    title: "Industrial Surveillance",
    img: s2,
  },
  {
    id: 3,
    category: "Automation",
    title: "Smart Luxury Villa",
    img: s3,
  },
  {
    id: 4,
    category: "Software",
    title: "E-commerce Platform",
    img: s4,
  },
  {
    id: 5,
    category: "CCTV",
    title: "City-wide Monitoring",
    img: s5,
  },
  {
    id: 6,
    category: "Automation",
    title: "Office Automation",
    img: s6,
  },
];

const GalleryPage = () => {
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const filteredProjects =
    filter === "All"
      ? projects
      : projects.filter((p) => p.category === filter);

  return (
    <div className="gallery-page">
      {/* HEADER */}
      <section className="gallery-hero">
        <div className="container">
          <span className="premium-tag" data-aos="fade-up">
            Our Portfolio
          </span>

          <h1 data-aos="fade-up" data-aos-delay="100">
            Showcasing <span className="text-gradient">Excellence</span>
          </h1>

          <p data-aos="fade-up" data-aos-delay="200">
            A collection of our most sophisticated digital and hardware
            integrations.
          </p>
        </div>
      </section>

      {/* FILTER */}
      <section className="filter-wrapper">
        <div className="container">
          <div className="filter-buttons">
            {["All", "Software", "CCTV", "Automation"].map((cat) => (
              <button
                key={cat}
                className={`filter-btn ${filter === cat ? "active" : ""}`}
                onClick={() => setFilter(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* GALLERY */}
      <section className="portfolio-grid-section">
        <div className="container">
          <div className="masonry-grid">
            {filteredProjects.map((project) => (
              <div
                key={project.id}
                className="portfolio-item"
                data-aos="zoom-in"
              >
                <div className="project-card">
                  <div className="img-container">
                    <img
                      src={project.img}
                      alt={project.title}
                      className="project-image"
                    />

                    <div className="card-overlay">
                      <span className="project-cat">
                        {project.category}
                      </span>

                      <h3 className="project-title">
                        {project.title}
                      </h3>

                      <button className="view-details-btn">
                        View Project
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default GalleryPage;